var render = function render(_c,_vm){return _c('path',{attrs:{"fill-rule":"nonzero","d":"M14.32 12.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387a8 8 0 1 1 1.414-1.414zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }